import { Avatar, Box, Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { LanguageContext } from '../../../../../../../libs/Context';
import { useParams } from 'react-router-dom';
import WebinarDesc from './WebinarDesc';
import { getSpeakersList } from '../../../../../../actions/meeting_actions';

const PreviewLeft = (props) =>
{
	const { data } = props;
	const { type } = useParams();
	const { language } = useContext(LanguageContext);
	const [ speakerList, setSpeakerList ] = useState([]);

	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));

	const fetchSpeakersList = async () =>
	{
		const query = {
			sessionId : data?.id,
			limit     : 10,
			skip      : 0

		};

		try
		{
			const res = await getSpeakersList(query);

			if (res?.status)
			{
				setSpeakerList(res?.data);
			}
		}
		catch (error:any)
		{
			// eslint-disable-next-line no-console
			console.log('err', error);
		}
	};

	useEffect(() =>
	{
		fetchSpeakersList();
	}, []);

	return (
		<Stack direction={'column'} height='var(--percent100)'>
			{type === 'waiting' && <Box pt='var(--pixel8)' pb={'var(--pixel16)'} width={'var(--percent100)'} sx={{ aspectRatio: '16/9' }}>
				<ReactPlayer className='playerCntr'style={{ borderRadius: 'var(--pixel8)', overflow: 'hidden' }} width={'var(--percent100)'} height={'var(--percent100)'} url={'https://www.youtube.com/embed/CPITNY7apXU'} controls />
			</Box>}
			{/* <RegisterDetails/> */}
			<Grid container direction={'column'} spacing={1}>
				<Grid item pt='var(--pixel16)'>
					<Stack spacing={1}>
						<Typography fontSize={'var(--pixel18)'} sx={{ fontWeight: '500' }}>{language?.abtThisWebinar}</Typography>
						<WebinarDesc description={data?.meetingDescription}/>
					</Stack>
				</Grid>
			</Grid>
			<Grid container spacing={2} py='var(--pixel16)'>
				{speakerList.map((card:any) => (
					<Grid item key={card?._id} xs={12} sm={6} lg={4} mb={1}>
						<Grid container spacing={2} alignItems='start'>
							<Grid item>
								<Stack direction={'column'} alignItems={'center'} spacing={1}>
									{/* <Avatar src='https://wallpapercave.com/wp/wp4807592.jpg' */}
									<Avatar src='/images/icons/individual-user.jpg'
										sx={{ height: downSM ? 80 : 90, width: downSM ? 80 : 90 }}
									/>
								</Stack>
							</Grid>
							<Grid item xs>
								<Stack spacing={0.5}>
									<Typography variant='subtitle2'>{card?.speakerName}</Typography>
									<Typography fontSize={'var(--pixel12)'} color={'var(--txtColorBlackL)'} fontWeight='var(--font500)'>{language?.Speakers}</Typography>
									<Typography variant='body2' fontWeight='500' noWrap>{card?.designation || card?.organization}</Typography>
									<Stack direction='row' spacing={1} pt='var(--pixel8)' style={{ opacity: 0.4 }}>

										{/* websiteUrl */}
										{card?.facebookUrl && <Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='images/icons/facebook.svg' />}
										{card?.linkedinUrl && <Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='/images/icons/linkedIn.svg' />}
										{card?.twitterUrl && <Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='/images/logos/webTwitt.svg' />}
									</Stack>
								</Stack>
							</Grid>
						</Grid>
					</Grid>
				))}
			</Grid>
		</Stack>
	);
};

export default PreviewLeft;
